export const zIndexMap = {
  shared: {
    languageSelector: 30,
    languageMenu: 40,
  },
  auth: {
    languageSelector: 30,
    languageMenu: 40,
  },
  phoneEntry: {
    countrySelector: 10,
    clearAction: 20,
    countryMenu: 50,
  },
  homeDashboard: {
    referralBackground: 0,
    referralForeground: 1,
  },
  withdrawal: {
    overlay: 70,
    sheet: 80,
  },
  raffle: {
    breakdownConnectors: 0,
    breakdownNodes: 1,
    chanceIllustration: 0,
    chanceContent: 1,
    countdown: 2,
    heroVisual: 0,
    heroCopy: 1,
  },
  referralBonus: {
    overlay: 70,
    sheet: 80,
  },
  myPageProfile: {
    avatarEditorOverlay: 70,
    goalResetTipOverlay: 1,
  },
  myPageSettings: {
    previewOverlay: 70,
    taxIdHelpOverlay: 71,
    logoutConfirmOverlay: 72,
  },
  tipsShare: {
    overlay: 70,
    sheet: 80,
  },
  tipsCheckout: {
    promoForeground: 1,
    overlay: 70,
    sheet: 80,
  },
  registration: {
    photoGuideCard: 0,
    photoGuideNote: 1,
    taxIdHelpOverlay: 60,
  },
} as const;
